// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".gray{color:#292727}.start-trial{color:#292727;text-align:center}.start-trial button{margin-top:1rem}.start-trial button:hover{color:#dabc64}.start-trial h1{font-size:1.8rem;margin-top:0;margin-bottom:1rem;font-weight:300;text-transform:uppercase}\n", ""]);
// Exports
module.exports = exports;
